export var FeatureStatus;
(function (FeatureStatus) {
    FeatureStatus["NoUserSubscription"] = "NoUserSubscription";
    FeatureStatus["NotInCurrentPlan"] = "NotInCurrentPlan";
    FeatureStatus["InCurrentPlanButExpired"] = "InCurrentPlanButExpired";
    FeatureStatus["Entitled"] = "Entitled";
})(FeatureStatus || (FeatureStatus = {}));
